<script>
	import User from "../play/User.svelte";
	import { gamerule } from "../lib/gameRules.js";
	import { map } from "../lib/map.js";

	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let team;
	export let showUsers = false;
	export let showCurrentRiddle = false;
	export let showFinish = false;
	export let showInOrder = false;
	export let showTime = false;
	export let advanced = true;
	export let chatControls = false; // NEW

	export let geoOverwrite = false;
	export let editVariant = false;
	export let manualPoints = false;

	let manualModiPoints = 0;
	let teamVariant = team.teamVariant || "default";

	// $: team,
	// 	() => {
	// 		if (!team.session.exodus) calculatePoints();
	// 	};

	$: if (team && !team.session.exodus) {
		calculatePoints();
	}

	// export let lang;
	// const dispatch = createEventDispatcher();
	// console.log(team);

	let players = Object.values(team.session.players);
	// console.log(players);

	let scoreData = {};
	let finish = false;

	function calculatePoints() {
		if (team.session.ended) {
			finish = false;
			// console.log(team.session);
			scoreData.startTime = team.session.sessionStart.toDate();
			scoreData.endTime = team.session.sessionEnd.toDate(); //|| team.session.sessionStart.toDate() default to start time if there's an issue

			scoreData.duration =
				(scoreData.endTime.getTime() - scoreData.startTime.getTime()) / 1000;

			scoreData.duration_floor = Math.floor(
				(scoreData.endTime.getTime() - scoreData.startTime.getTime()) / 1000,
			);

			// OLD score_from_normal_riddles
			scoreData.OLD_score_from_normal_riddles =
				team.session.normal_riddles_solved * gamerule.points_for_normal_riddle;
			// console.log(team.session);

			// => NEW score_from_normal_riddles
			scoreData.score_from_normal_riddles = team.session
				.normal_riddles_solved_ids
				? team.session?.normal_riddles_solved_ids?.length *
					gamerule.points_for_normal_riddle
				: 0;

			// OLD score_from_bonus_riddles
			scoreData.OLD_score_from_bonus_riddles = team.session.bonus_riddles_solved
				? team.session.bonus_riddles_solved * gamerule.points_for_bonus_riddle
				: 0;

			// => NEW score_from_bonus_riddles
			scoreData.score_from_bonus_riddles = team.session.bonus_riddles_solved_ids
				? team.session.bonus_riddles_solved_ids.length *
					gamerule.points_for_bonus_riddle
				: 0;

			// score_bonus_from_time
			if (scoreData.duration_floor <= 7200) {
				scoreData.score_bonus_from_time = Math.round(
					map(scoreData.duration_floor, 900, 7200, 500, 250),
				);
			} else {
				scoreData.score_bonus_from_time = Math.round(
					map(scoreData.duration_floor, 7200, 86400, 250, 100),
				);
			}

			scoreData.durationDays = Math.floor(scoreData.duration / 86400);
			scoreData.durationHours = Math.floor((scoreData.duration % 86400) / 3600);
			scoreData.durationMinutes = Math.floor(
				((scoreData.duration % 86400) % 3600) / 60,
			);
			scoreData.durationSeconds = Math.floor(
				((scoreData.duration % 86400) % 3600) % 60,
			);

			if (team.hints) {
				scoreData.usedHintsArray = Object.keys(team.hints.hintsUsed);
				scoreData.usedHintsTime = 0;
				scoreData.usedHintsCount = 0;

				scoreData.usedHintsArray.forEach((element) => {
					let keys = Object.keys(team.hints.hintsUsed[element]);
					let values = Object.values(team.hints.hintsUsed[element]);
					// console.log(keys, values);
					scoreData.usedHintsCount = scoreData.usedHintsCount + keys.length;

					values.forEach((element) => {
						scoreData.usedHintsTime = scoreData.usedHintsTime + element;
					});
				});
			} else {
				scoreData.usedHintsTime = 0;
				scoreData.usedHintsCount = 0;
			}

			scoreData.minus_for_hints = scoreData.usedHintsTime;

			// score_normal_minus_hints
			scoreData.score_normal_minus_hints =
				scoreData.score_from_normal_riddles - scoreData.minus_for_hints;

			// manual modifier
			scoreData.score_from_manual_modifier = team.session.manualModifier
				? Number(team.session.manualModifier)
				: 0;

			console.log(scoreData);

			// wrong answers penalty
			scoreData.penalty_from_wrong_answers = calculatePenaltyByRiddle(
				team.wrongAnswers,
			);
			// console.log(
			// 	team.team_name,
			// 	"Total:",
			// 	scoreData.penalty_from_wrong_answers.totalPenalty
			// );
			// console.table(scoreData.penalty_from_wrong_answers.perRiddle);

			scoreData.totalScore =
				scoreData.score_from_normal_riddles +
				scoreData.score_from_bonus_riddles +
				scoreData.score_normal_minus_hints +
				scoreData.score_bonus_from_time -
				Math.floor(scoreData.penalty_from_wrong_answers.totalPenalty) +
				scoreData.score_from_manual_modifier;

			scoreData.OLD_totalScore =
				scoreData.OLD_score_from_normal_riddles +
				scoreData.OLD_score_from_bonus_riddles +
				scoreData.score_normal_minus_hints +
				scoreData.score_bonus_from_time;
			// console.log(scoreData.totalScore);
			finish = scoreData.totalScore + " points";
			// scoreData.totalTime = scoreData.duration + scoreData.usedHintsTime * 60;
			// scoreData.totalDays = Math.floor(scoreData.totalTime / 86400);
			// scoreData.totalHours = Math.floor((scoreData.totalTime % 86400) / 3600);
			// scoreData.totalMinutes = Math.floor(((scoreData.totalTime % 86400) % 3600) / 60);
			// scoreData.totalSeconds = Math.floor(((scoreData.totalTime % 86400) % 3600) % 60);
		} else {
			finish = false;
		}
	}

	// calculateHints

	// if (team.session.hints) {
	// 	team.session.usedHintsArray = Object.keys(team.session.hints.hintsUsed);
	// 	scoreData.usedHintsTime = 0;
	// 	scoreData.usedHintsCount = 0;

	// 	team.session.usedHintsArray.forEach((element) => {
	// 		let keys = Object.keys(team.session.hints.hintsUsed[element]);
	// 		let values = Object.values(team.session.hints.hintsUsed[element]);
	// 		// console.log(keys, values);
	// 		scoreData.usedHintsCount = scoreData.usedHintsCount + keys.length;

	// 		values.forEach((element) => {
	// 			scoreData.usedHintsTime = scoreData.usedHintsTime + parseInt(element);
	// 		});
	// 	});
	// } else {
	// 	scoreData.usedHintsTime = 0;
	// 	scoreData.usedHintsCount = 0;
	// }

	function calculatePenaltyByRiddle(wrongAnswers) {
		const bands = [
			{ min: 1, max: 3, penalty: 1.0 },
			{ min: 4, max: 6, penalty: 1.1 },
			{ min: 7, max: 10, penalty: 1.13 },
			{ min: 11, max: 15, penalty: 1.16 },
			{ min: 16, max: 25, penalty: 1.2 },
			{ min: 26, max: 40, penalty: 1.25 },
			{ min: 41, max: 60, penalty: 1.3 },
			{ min: 61, max: Infinity, penalty: 1.6 },
		];

		let totalPenalty = 0;
		const perRiddle = {};

		for (const riddleId in wrongAnswers) {
			const playerMap = wrongAnswers[riddleId];
			let riddleWrongCount = 0;

			for (const playerId in playerMap) {
				riddleWrongCount += playerMap[playerId].length;
			}

			if (riddleWrongCount === 0) continue;

			const band = bands.find(
				(b) => riddleWrongCount >= b.min && riddleWrongCount <= b.max,
			);
			const rawPenalty = riddleWrongCount * band.penalty;
			const cappedPenalty = Math.min(100, Math.round(rawPenalty * 100) / 100);

			perRiddle[riddleId] = {
				wrongAnswers: riddleWrongCount,
				multiplier: band.penalty,
				rawPenalty: Math.round(rawPenalty * 100) / 100,
				cappedPenalty,
			};

			totalPenalty += cappedPenalty;
		}

		return {
			totalPenalty: Math.round(totalPenalty * 100) / 100,
			perRiddle,
		};
	}

	// if (!team.session.exodus) {
	calculatePoints();
	// }

	function handleLimit(number) {
		dispatch("changeLimit", {
			number: number,
			session: team.access_code,
		});
	}
	function handleExodus() {
		if (
			confirm(
				"Are you sure you want to force team " +
					team.session.team_name +
					" into Exodus?",
			)
		) {
			dispatch("teamExodus", {
				session: team.access_code,
			});
		}
	}
	function handleGeoOverwrite() {
		dispatch("overwriteGeoLock", {
			state: !team.geoOverwrite,
			session: team.access_code,
		});
	}
	function handleVariant() {
		dispatch("changeVariant", {
			variant: teamVariant,
			session: team.access_code,
		});
	}
	function handleManualPoints() {
		dispatch("changeManualModifier", {
			manual: manualModiPoints,
			session: team.access_code,
		});
	}
</script>

<div
	class="gap-2 p-4 bg-white border bg-opacity-20 grow relative teamview"
	id={team.session.sid}
	data-finish={team.session.started
		? team.session.exodus
			? "exodus"
			: finish
		: "nonstart"}
	style={showInOrder
		? finish
			? team.session.exodus
				? "order:" + -1
				: "order:" + scoreData.totalScore
			: ""
		: ""}
>
	<!-- {team.} -->
	<h3>{team.session.team_name}</h3>
	{#if showUsers}
		<div class={showInOrder ? "flex flex-wrap gap-4" : ""}>
			{#each players as player}
				<User name={player.name} photo={player.pic} />
			{/each}
		</div>
	{/if}
	{#if showCurrentRiddle && team.session.started}
		<!-- team.session.started ? team.session.exodus ? "exodus" : finish : "nonstart" -->
		<i class="fa-solid fa-puzzle-piece" />
		{team.current_task}
		<br />
		<i class="fa-solid fa-stopwatch" />
		{team.session.sessionStart.toDate().toLocaleString()}
		<br />
		{#if team.session.bonus_riddles_solved || team.session.normal_riddles_solved}
			<i class="fa-solid fa-shapes" />
		{/if}
		{#if team.session.bonus_riddles_solved}
			<span class="opacity-50">{team.session.bonus_riddles_solved} bonus /</span
			>
		{/if}
		{#if team.session.bonus_riddles_solved_ids}
			{team.session.bonus_riddles_solved_ids.length} bonus /
		{/if}
		{#if team.session.normal_riddles_solved}
			<span class="opacity-50">{team.session.normal_riddles_solved} normal</span
			>
		{/if}
		{#if team.session.normal_riddles_solved_ids}
			{team.session.normal_riddles_solved_ids.length} normal
		{/if}
		<br />
	{/if}

	{#if showCurrentRiddle && advanced}
		<i class="fa-solid fa-gear" />
		{team.access_code} · {team.game.limit}
		<br />
		<button on:click={() => handleLimit(1)}>Limit +</button> /
		<button on:click={() => handleLimit(-1)}>Limit -</button>
		—
		<button on:click={handleExodus}>Exodus</button>
	{/if}

	{#if geoOverwrite && advanced}
		<br />
		<i class="fa-solid fa-location-pin-lock" />
		{team.geoOverwrite || false}

		—
		<button on:click={handleGeoOverwrite}
			>{team.geoOverwrite ? "Reset" : "Overwrite"}</button
		>
	{/if}
	{#if manualPoints && advanced}
		<br />
		<i class="fa-solid fa-hand" />
		{#if manualPoints == "edit"}
			<input
				class="!p-2 !m-1"
				id="manual-number"
				name="manual-number"
				type="number"
				bind:value={manualModiPoints}
			/>

			—
			<button on:click={handleManualPoints}>Set Manual Modifier</button>
			<button
				on:click={() => {
					manualPoints = "view";
				}}><i class="fa-solid fa-square-xmark" /></button
			>
		{:else}
			{manualModiPoints} |
			<button
				on:click={() => {
					manualPoints = "edit";
				}}><i class="fa-solid fa-square-pen" /></button
			>
		{/if}
	{/if}
	{#if editVariant && advanced}
		<br />
		<i class="fa-solid fa-shapes" />
		{#if editVariant == "edit"}
			<input
				class="!p-2 !m-1"
				id="team-variant"
				name="team-variant"
				type="text"
				bind:value={teamVariant}
			/>

			—
			<button on:click={handleVariant}>Set Variant</button>
			<button
				on:click={() => {
					editVariant = "view";
				}}><i class="fa-solid fa-square-xmark" /></button
			>
		{:else}
			{teamVariant} |
			<button
				on:click={() => {
					editVariant = "edit";
				}}><i class="fa-solid fa-square-pen" /></button
			>
		{/if}
	{/if}
	{#if chatControls && advanced}
		<br />
		<!-- 1. Master Chat Access Toggle -->
		<i class="fa-solid fa-messages" />
		Chat: {team.chatEnabled !== false ? "Enabled" : "Disabled"}
		—
		<button
			on:click={() =>
				dispatch("toggleChat", {
					state: team.chatEnabled === false ? true : false,
					session: team.access_code,
				})}
		>
			{team.chatEnabled !== false ? "Disable" : "Enable"}
		</button>

		<br />
		<!-- 2. Player Input Toggle -->
		<i class="fa-solid fa-keyboard" />
		Input: {team.playerInputEnabled !== false ? "Enabled" : "Disabled"}
		—
		<button
			on:click={() =>
				dispatch("togglePlayerInput", {
					state: team.playerInputEnabled === false ? true : false,
					session: team.access_code,
				})}
		>
			{team.playerInputEnabled !== false ? "Disable" : "Enable"}
		</button>

		|
		<!-- 3. Open Chat Button with Notification Badge -->
		<button class="relative" on:click={() => dispatch("openGmChat", { team })}>
			Open Chat
			{#if team.unreadPlayerMessages > 0}
				<div
					class="absolute flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full -top-2 -right-3 animate-pulse"
				>
					{team.unreadPlayerMessages > 9 ? "9+" : team.unreadPlayerMessages}
				</div>
			{/if}
		</button>
	{/if}

	{#if finish && showFinish}
		<br />
		{#if team.session.exodus}
			<i class="fa-solid fa-person-through-window" />
			Exodus
		{:else}
			<i class="fa-solid fa-flag-checkered" />
			{finish}
			<span class="opacity-50">
				{scoreData.OLD_totalScore
					? " · " + scoreData.OLD_totalScore + " old points "
					: ""}</span
			>
			{#if showCurrentRiddle}
				<small class="opacity-80">
					<i class="fa-solid fa-lock"></i>
					{scoreData.score_from_normal_riddles} ·
					<i class="fa-solid fa-square-plus"></i>
					{scoreData.score_from_bonus_riddles} ·
					<i class="fa-solid fa-lightbulb"></i>
					{scoreData.score_normal_minus_hints} ·
					<i class="fa-solid fa-stopwatch"></i>
					{scoreData.score_bonus_from_time} ·
					<i class="fa-solid fa-hexagon-xmark"></i>
					{Math.floor(scoreData.penalty_from_wrong_answers.totalPenalty)} ·
					<i class="fa-solid fa-hand"></i>
					{scoreData.score_from_manual_modifier}
				</small>
			{/if}
			<!-- scoreData.score_from_normal_riddles +
				scoreData.score_from_bonus_riddles +
				scoreData.score_normal_minus_hints +
				scoreData.score_bonus_from_time +
				scoreData.score_from_manual_modifier; -->
		{/if}
		{#if showTime}
			<br />
			<i class="fa-solid fa-lightbulb" />
			{scoreData.usedHintsCount} · {scoreData.usedHintsTime} points
			<!-- ///HINTS USED /// -->

			<br />
			<i class="fa-solid fa-stopwatch" />
			{#if scoreData.durationDays}
				{scoreData.durationDays < 10
					? "0" + scoreData.durationDays
					: scoreData.durationDays}
				{scoreData.durationDays == 1 ? "day" : "days"},
			{/if}
			{#if scoreData.durationHours || scoreData.durationHours === 0}
				{scoreData.durationHours < 10
					? "0" + scoreData.durationHours
					: scoreData.durationHours} :
			{/if}
			{#if scoreData.durationMinutes || scoreData.durationMinutes === 0}
				{scoreData.durationMinutes < 10
					? "0" + scoreData.durationMinutes
					: scoreData.durationMinutes} :
			{/if}
			{#if scoreData.durationSeconds || scoreData.durationSeconds === 0}
				{scoreData.durationSeconds < 10
					? "0" + scoreData.durationSeconds
					: scoreData.durationSeconds}
			{/if}
		{/if}
	{/if}
</div>

<style>
	.teamview[data-finish="exodus"] {
		border-color: orange;
		background-color: rgba(255, 165, 0, 0.2);
	}
	.teamview[data-finish="exodus"]:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		border-top: 30px solid orange;
		border-right: 30px solid transparent;
	}
	.teamview[data-finish="false"] {
		border-color: chartreuse;
		background-color: rgba(127, 255, 0, 0.2);
	}
	.teamview[data-finish="false"]:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		border-top: 30px solid chartreuse;
		border-right: 30px solid transparent;
	}

	.teamview[data-finish="nonstart"] {
		border-color: lightskyblue;
		background-color: rgba(0, 242, 255, 0.2);
	}
	.teamview[data-finish="nonstart"]:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		border-top: 30px solid lightskyblue;
		border-right: 30px solid transparent;
	}

	button:not(.default),
	.obelisk button:not(.default) {
		padding: 0 0.6em !important;
		background: white !important;
		margin: initial !important;
		font-size: 0.8em !important;
		color: initial !important;
	}
	button:hover,
	.obelisk button:not(.default):hover {
		background: #3ce1bb !important;
	}

	button:active,
	.obelisk button:not(.default):active {
		background: #093986 !important;
		color: white !important;
	}
</style>
